import { useEffect, useState } from 'react';
import { api } from '../api';
import type { Kunde } from '../types';
import { KundeFormular } from './KundeFormular';
import { kundenName } from './ui';

/**
 * Kunde zuerst: suchen, und nur wenn nichts passt, neu anlegen - mit der
 * Dublettenprüfung des Formulars. Gibt den gewählten Kunden zurück.
 */
export function KundenAuswahl({ gewaehlt, onWahl }: { gewaehlt: Kunde | null; onWahl: (k: Kunde | null) => void }) {
  const [q, setQ] = useState('');
  const [treffer, setTreffer] = useState<Kunde[]>([]);
  const [anlegen, setAnlegen] = useState(false);

  useEffect(() => {
    if (q.trim().length < 2) {
      setTreffer([]);
      return;
    }
    const zeit = window.setTimeout(() => {
      api<Kunde[]>('/api/kunden', { query: { q } })
        .then((r) => setTreffer(r.slice(0, 8)))
        .catch(() => setTreffer([]));
    }, 250);
    return () => window.clearTimeout(zeit);
  }, [q]);

  const waehleId = async (id: string) => {
    const r = await api<{ kunde: Kunde }>(`/api/kunden/${id}`);
    onWahl(r.kunde);
    setAnlegen(false);
  };

  if (gewaehlt) {
    return (
      <div className="dublette">
        <div className="wer">
          <strong>{kundenName(gewaehlt)}</strong> <span className="muted mono">{gewaehlt.kundennummer}</span>
          <div className="small muted">{[gewaehlt.strasse, [gewaehlt.plz, gewaehlt.ort].filter(Boolean).join(' ')].filter(Boolean).join(', ')}</div>
        </div>
        <button type="button" className="klein" onClick={() => onWahl(null)}>
          Anderer Kunde
        </button>
      </div>
    );
  }

  if (anlegen) {
    // Was schon im Suchfeld stand, gleich übernehmen: Ziffern als Telefon, sonst als Nachname.
    const ziffern = /^[\d\s+/()-]{5,}$/.test(q.trim());
    return (
      <div className="card">
        <div className="body">
          <KundeFormular
            vorbelegung={ziffern ? { telefone: [{ nummer: q.trim(), art: 'telefon' }] } : { nachname: q.trim() }}
            onGespeichert={(k) => {
              onWahl(k);
              setAnlegen(false);
            }}
            onVorhandenen={(id) => void waehleId(id)}
            onAbbrechen={() => setAnlegen(false)}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="stack" style={{ gap: 6 }}>
      <input placeholder="Name, Telefon, PLZ oder Kundennummer …" value={q} onChange={(e) => setQ(e.target.value)} autoFocus />
      {treffer.map((k) => (
        <button type="button" key={k.id} className="dublette" style={{ textAlign: 'left', fontWeight: 400 }} onClick={() => onWahl(k)}>
          <div className="wer">
            <strong>{kundenName(k)}</strong> <span className="muted mono">{k.kundennummer}</span>
            <div className="small muted">
              {[k.strasse, [k.plz, k.ort].filter(Boolean).join(' ')].filter(Boolean).join(', ')}
              {(k.telefone as string[]).length > 0 && ` · ${(k.telefone as string[]).join(', ')}`}
            </div>
          </div>
        </button>
      ))}
      {q.trim().length >= 2 && treffer.length === 0 && <div className="small muted">Kein Kunde gefunden.</div>}
      <div>
        <button type="button" className="link" onClick={() => setAnlegen(true)}>
          + Neuen Kunden anlegen
        </button>
      </div>
    </div>
  );
}
